var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"mt-4",attrs:{"type":"error"}},[_c('h3',[_vm._v("Not Found")]),_vm._v(" Ups, la página que intentas visitar no existe, ir a "),_c('router-link',{attrs:{"to":{name: 'home', params: {msisdn: ''}}}},[_vm._v("Home")]),_vm._v(". ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }